module.exports = __webpack_public_path__ + "static/media/catandbook.d1badf3c.gif";